
import { Link } from 'react-router-dom';

export default function HeroSection() {
  // Keep the long image URL in a separate constant for readability.
  const heroImageUrl =
    'https://public.readdy.ai/ai/img_res/7e25b64c35028f705f527f1dc1dbe3bc.jpg';

  return (
    <section className="relative min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={heroImageUrl}
          alt="Diverse American farmland aerial view"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 text-center pt-28 pb-16">
        <p className="text-emerald-400 font-bold text-xs tracking-widest uppercase mb-5">
          Industries We Serve
        </p>
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
          Your Land, Our Partnership
        </h1>
        <p className="text-xl text-gray-200 max-w-2xl mx-auto leading-relaxed font-light mb-10">
          From row crops to woodlands, vineyards to conservation land — we work
          alongside farmers and landowners who value yield, timing, and
          stewardship. Every acre matters.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="/#contact"
            className="inline-block bg-emerald-700 hover:bg-emerald-600 text-white font-bold px-8 py-3.5 rounded-md transition-colors cursor-pointer whitespace-nowrap"
          >
            Talk About Your Operation
          </a>
          <Link
            to="/services"
            className="inline-flex items-center justify-center gap-2 border-2 border-white/40 hover:bg-white/10 text-white font-bold px-8 py-3.5 rounded-md transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-right-line"></i>
            View Our Services
          </Link>
        </div>
      </div>
    </section>
  );
}
